import { SortDirection, VisualFieldDto } from 'src/app/services/api.services';
import { VisualChartType } from '../chart-type';
import { VisualChartRoleCategorisation, PbiDataRoles } from '../data-role';
import { SortingGroups } from '../sorting-groups';
import { PieChartVisual } from 'src/app/pbir/visuals/highcharts/PieChartVisual.component';

export const PielikeChartTypes = {
  pieChart: <VisualChartType<PieChartVisual.Options>>{
    name: 'pieChart',
    alias: 'pieChart',
    dataRoles: {
      rows: PbiDataRoles.pieDonutLegend,
      columns: PbiDataRoles.pieDonutDetails,
      values: PbiDataRoles.pieDonutMeasures
    },
    sortingDataRoles: [PbiDataRoles.pieDonutLegend, PbiDataRoles.pieDonutDetails],
    defaultSortDirection: SortDirection.Ascending,
    title: 'Pie Chart',
    icon: 'far fa-chart-pie',
    previewImageUrl: '/assets/img/icons/chart-pie-solid.svg',
    previewWhiteImageUrl: '/assets/img/icons-white/chart-pie-solid.svg',
    previewRedImageUrl: '/assets/img/icons-red/chart-pie-solid.svg',
    previewGreyImageUrl: '/assets/img/icons-grey/chart-pie-solid.svg',

    defaultDataRoles: {
      measuresDataRole: PbiDataRoles.pieDonutMeasures.name,
      fallbackDataRole: PbiDataRoles.pieDonutLegend.name
    },

    getDataRoleOptions: (params) => ({
      rows: {
        maxFields: 1,
        replace: true,
      },
      columns: {
        maxFields: 1,
        disabled: (params.values?.fieldCount ?? 0) > 1,
        disabledMessage: 'Cannot add items to Details, because you have more than one item in Measures.',
        replace: true,
      },
      values: {
        ...(((params.columns?.fieldCount ?? 0) > 0) ? {
          maxFields: 1,
          replace: true
        } : {
          fieldCountForScroll: 12
        }),
      }
    }),

    roleCategorisation: VisualChartRoleCategorisation.Categorised,

    sortingGroups: [
      SortingGroups.pieValue,
      // SortingGroups.pieDetails
    ],

    visualType: PieChartVisual.type,
    visualTypeOptions: {
      visualOptions: {
        ...PieChartVisual.type.visualOptions,
        displayType: PieChartVisual.DisplayType.Pie
      }
    },
  },

  donutChart: <VisualChartType<PieChartVisual.Options>>{
    name: 'donutChart',
    alias: 'donutChart',
    dataRoles: {
      rows: PbiDataRoles.pieDonutLegend,
      columns: PbiDataRoles.pieDonutDetails,
      values: PbiDataRoles.pieDonutMeasures
    },
    sortingDataRoles: [PbiDataRoles.pieDonutLegend, PbiDataRoles.pieDonutDetails],
    defaultSortDirection: SortDirection.Ascending,
    title: 'Donut Chart',
    icon: 'far fa-chart-pie',
    previewImageUrl: '/assets/img/icons/chart-donut-solid.svg',
    previewWhiteImageUrl: '/assets/img/icons-white/chart-donut-solid.svg',
    previewRedImageUrl: '/assets/img/icons-red/chart-donut-solid.svg',
    previewGreyImageUrl: '/assets/img/icons-grey/chart-donut-solid.svg',

    defaultDataRoles: {
      measuresDataRole: PbiDataRoles.pieDonutMeasures.name,
      fallbackDataRole: PbiDataRoles.pieDonutLegend.name
    },

    getDataRoleOptions: (params) => ({
      rows: {
        maxFields: 1,
        replace: true,
      },
      columns: {
        maxFields: 1,
        disabled: (params.values?.fieldCount ?? 0) > 1,
        disabledMessage: 'Cannot add items to Details, because you have more than one item in Measures.',
        replace: true,
      },
      values: {
        ...(((params.columns?.fieldCount ?? 0) > 0) ? {
          maxFields: 1,
          replace: true
        } : {
          fieldCountForScroll: 12
        }),
      }
    }),

    roleCategorisation: VisualChartRoleCategorisation.Categorised,

    sortingGroups: [
      SortingGroups.pieValue,
      // SortingGroups.pieDetails
    ],

    visualType: PieChartVisual.type,
    visualTypeOptions: {
      visualOptions: {
        ...PieChartVisual.type.visualOptions,
        displayType: PieChartVisual.DisplayType.Donut
      },
    },
  },
};
